import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminToken = () => localStorage.getItem("ci_admin_token") || "";
export const adminHeaders = () => ({ "X-Admin-Token": adminToken() });

export default api;
